import { locationAdapter, LocationState, MyOrganizationState } from "@organizations/models";
import { selectMyOrganizationsState, locationsReducer } from "@organizations/store/reducers";
import { createSelector } from "@ngrx/store";

const { selectEntities, selectAll } = locationAdapter.getSelectors();

export const selectLocationsState = createSelector(
  selectMyOrganizationsState,
  (state: MyOrganizationState) => state.locations as LocationState
);

export const selectLocationEntities = createSelector(selectLocationsState, selectEntities);
export const selectAllLocations = createSelector(selectLocationsState, selectAll);

export const selectLocationsLoading = createSelector(
  selectLocationsState,
  locationsReducer.getLocationsLoading
);

export const selectLocationNameById = (entityId: string) =>
  createSelector(selectLocationEntities, (entities) => entities[entityId]!.name);
